<template>
  <v-container>
    <v-row class="alert hawksoft-danger" justify="center" align="center">
      <v-col class="text-lg-center">
        <v-icon x-large color="black">warning</v-icon>
        <h1>Unauthorized</h1>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col class="text-center">
        Please close the browser and relaunch Marketplace from CMS
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'Unauthorized'
};
</script>
